import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// Import the new action
import { getProgressAction } from "../../../actions/quizActions";

/**
 * Fetches the user's Art of Looking progress using the new Redux setup.
 */
export const useUserProgress = () => {
  const dispatch = useDispatch();

  // Select from the new state slice: artOfLookingProgress
  const progressState = useSelector((state) => state.artOfLookingProgress);
  const { userInfo } = useSelector((state) => state.userLogin);

  useEffect(() => {
    if (userInfo) {
      // Dispatch the new, correct action
      dispatch(getProgressAction());
    }
  }, [dispatch, userInfo]);

  // Return the data in the new shape
  return {
    progressData: progressState?.progress,
    isLoading: progressState?.loading,
  };
};
